import React from 'react'
import { CarouselWrapperProps } from './types'
import './index.scss'
import { IConfig, TBreakpoint } from '@petz/ds-carousel/dist/Carousel/types'
import { Carousel } from '@petz/ds-carousel'

export const CarouselWrapper: React.FC<CarouselWrapperProps> = ({ id, children, size }) => {
  const breakpointsFullSize: TBreakpoint = {
    0: { slidesPerView: 1.5, slidesPerGroup: 1, spaceBetween: 'md' },
    400: { slidesPerView: 1.8, slidesPerGroup: 1, spaceBetween: 'md' },
    500: { slidesPerView: 2.2, slidesPerGroup: 2, spaceBetween: 'sm' },
    620: { slidesPerView: 2.6, slidesPerGroup: 2, spaceBetween: 'md' },
    700: { slidesPerView: 3.1, slidesPerGroup: 2, spaceBetween: 'md' },
    768: { slidesPerView: 3.5, slidesPerGroup: 3, spaceBetween: 'xl' },
    900: { slidesPerView: 4.2, slidesPerGroup: 3, spaceBetween: 'md' },
    992: { slidesPerView: 4.5, slidesPerGroup: 4, spaceBetween: 'md' },
    1100: { slidesPerView: 4.5, slidesPerGroup: 4, spaceBetween: 'xl' },
    1200: { slidesPerView: 5.5, slidesPerGroup: 3, spaceBetween: 'xl' },
    1500: { slidesPerView: 6, slidesPerGroup: 3, spaceBetween: 'xl' },
  }

  const breakpointsHalfSize: TBreakpoint = {
    0: { slidesPerView: 1.5, slidesPerGroup: 1, spaceBetween: 'md' },
    400: { slidesPerView: 1.8, slidesPerGroup: 1, spaceBetween: 'md' },
    500: { slidesPerView: 2.2, slidesPerGroup: 2, spaceBetween: 'sm' },
    620: { slidesPerView: 2.6, slidesPerGroup: 2, spaceBetween: 'md' },
    700: { slidesPerView: 3.1, slidesPerGroup: 2, spaceBetween: 'md' },
    768: { slidesPerView: 3.5, slidesPerGroup: 3, spaceBetween: 'xl' },
    900: { slidesPerView: 4.2, slidesPerGroup: 3, spaceBetween: 'md' },
    992: { slidesPerView: 4.5, slidesPerGroup: 4, spaceBetween: 'md' },
    1100: { slidesPerView: 4.5, slidesPerGroup: 4, spaceBetween: 'xl' },
    1200: { slidesPerView: 2.5, slidesPerGroup: 2, spaceBetween: 'xl' },
    1500: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 'xl' },
  }

  const getBreakpoint = () => {
    switch (size) {
      case 'full':
        return breakpointsFullSize

      case 'half':
        return breakpointsHalfSize

      default:
        console.error('Invalid size')
    }
  }

  const config: IConfig = {
    id: id,
    buttonSize: 'lg',
    infinite: false,
    paginationType: 'dynamic',
    breakpoints: getBreakpoint(),
  }

  return (
    <div className="carousel-wrapper">
      <Carousel config={config}>{children}</Carousel>
    </div>
  )
}
